<mat-accordion>
    @for (item of block.content; track trackByFn($index, item); let i = $index) {
        @if (item.data.title) {
            <mat-expansion-panel
                [expanded]="i === 0 && block.data.autoExpand"
                (opened)="onPanelOpened(i)"
                hideToggle="true"
                (closed)="setState(i, false)"
                #panel>
                <mat-expansion-panel-header
                    [collapsedHeight]="'auto'"
                    [expandedHeight]="'auto'"
                    [core-analytics]="{ action: [getPanelState(i), item.data.title].join(':'), block }">
                    <mat-expansion-indicator>
                        <svg height="28px" viewBox="0 0 28 28" width="28px" xmlns="http://www.w3.org/2000/svg">
                            <g
                                transform="rotate(-90, 14, 14)"
                                fill="none"
                                fill-rule="evenodd"
                                id="NIHIP-Arrow"
                                stroke="none"
                                stroke-width="1">
                                <g
                                    id="NIHIP-0002_WebsitePrivateArea_V2_100320---Executive-Committee-(Open)"
                                    transform="translate(-205.000000, -1766.000000)">
                                    <g id="Group-21" transform="translate(183.000000, 1745.000000)">
                                        <g id="Group-20">
                                            <g id="Group-12">
                                                <g
                                                    fill="#FFFFFF"
                                                    id="Group-7-Copy"
                                                    transform="translate(36.000000, 31.500000) rotate(-180.000000) translate(-36.000000, -31.500000) translate(22.000000, 21.000000)">
                                                    <path
                                                        d="M22.9461114,17.5343981 L14.2413429,5.12483809 C14.1839398,5.0428119 14.089049,4.99560258 13.9894722,5.00032351 C13.8986816,5.00386421 13.8155057,5.04989329 13.7627886,5.12483809 L10.8317166,9.30286295 C10.738583,9.43563916 10.7696275,9.61975551 10.9020061,9.71417415 C11.0337989,9.80859279 11.2165516,9.7767265 11.3102709,9.64395029 L14.0017729,5.80583254 L22.1418824,17.4098835 L5.29700443,17.4098835 C5.13533859,17.407523 5.00237429,17.5379388 5,17.7008109 C4.99768833,17.8636831 5.12713815,17.9976395 5.28880399,18 L5.29700443,18 L22.7071271,18 C22.8687929,18 23,17.8678139 23,17.7049417 C23,17.6441597 22.9812561,17.5839679 22.9461114,17.5343981"
                                                        id="Fill-1"></path>
                                                    <path
                                                        d="M8.58124213,14.8417168 L9.93839815,12.5953004 C10.0426963,12.4283167 10.0113429,12.1939406 9.86865274,12.0718853 C9.81362426,12.0254594 9.74771805,12 9.67989224,12 C9.57431433,12 9.47577495,12.0606532 9.41626741,12.1624908 L8.05911139,14.4089073 C7.95673281,14.5773885 7.99064572,14.8110158 8.13525546,14.9308247 C8.27922533,15.0506336 8.47886356,15.0109469 8.58124213,14.8417168"
                                                        id="Fill-3"></path>
                                                    <path
                                                        d="M13.9997679,1.37073994 L26.6265478,19.7991766 L1.37298792,19.7991766 L13.9997679,1.37073994 Z M0.915838583,21 L27.0836971,21 C27.8094144,21 28.2554707,20.0927779 27.840942,19.4875629 L14.7570127,0.390267612 C14.5783566,0.130289341 14.2887703,0 13.9997679,0 C13.7107654,0 13.4211791,0.130289341 13.242523,0.390267612 L0.159761456,19.4863621 C-0.255935003,20.0915771 0.190121309,21 0.915838583,21 L0.915838583,21 Z"
                                                        id="Fill-16"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </mat-expansion-indicator>
                    <mat-panel-title
                        [innerHTML]="item.data.title"
                        [attr.id]="item.data.anchorId ?? 'block--' + item.uid"></mat-panel-title>
                </mat-expansion-panel-header>
                <div
                    class="{{ block.data.title }} {{ block.data.visibility }}"
                    [ngClass]="{
                        container: block.data.columnsSmall === 'full' || block.data.columnsNormal === 'full',
                        'col-sm-12': block.data.columnsSmall === 'full',
                        'col-md-12': block.data.columnsNormal === 'full',
                    }"
                    [ngStyle]="{ padding: block.data.padding, margin: block.data.margin }">
                    @for (subBlock of item.content; track subBlock) {
                        <core-block [block]="subBlock" class="subWidget {{ subBlock.data.class }}"></core-block>
                    }
                </div>
            </mat-expansion-panel>
        }
    }
</mat-accordion>
